/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { ErrorType } from '../../modules/Network/orvalHTTPInterface';
import { HTTP } from '../../modules/Network/orvalHTTPInterface';

import type { ApiMetaDiscountExperimentRetrieve200 } from './model/apiMetaDiscountExperimentRetrieve200';

/**
 * Return the Statsig experiment arm for the Meta discount smoke test.

Unauthenticated — the experiment buckets on ``rover_cid``, which the
Statsig middleware attaches to ``request.statsig_user`` for every request
(authenticated or not) via ``StatsigUserBuilder.for_request()``.
 */
export const apiMetaDiscountExperimentRetrieve = (signal?: AbortSignal) => {
  return HTTP<ApiMetaDiscountExperimentRetrieve200>({
    url: `/api/v7/utilities/meta-discount-experiment/`,
    method: 'GET',
    signal,
  });
};

export const getApiMetaDiscountExperimentRetrieveQueryKey = () => {
  return [`/api/v7/utilities/meta-discount-experiment/`] as const;
};

export const getApiMetaDiscountExperimentRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiMetaDiscountExperimentRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiMetaDiscountExperimentRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiMetaDiscountExperimentRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMetaDiscountExperimentRetrieve>>> = ({
    signal,
  }) => apiMetaDiscountExperimentRetrieve(signal);

  return {
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof apiMetaDiscountExperimentRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiMetaDiscountExperimentRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiMetaDiscountExperimentRetrieve>>
>;
export type ApiMetaDiscountExperimentRetrieveQueryError = ErrorType<unknown>;

export function useApiMetaDiscountExperimentRetrieve<
  TData = Awaited<ReturnType<typeof apiMetaDiscountExperimentRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiMetaDiscountExperimentRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiMetaDiscountExperimentRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}
